import { fileToSave } from './selectors';

export const prefix = 'article';

export const GET_TYPES_REQUEST = `${prefix}/GET_TYPES_REQUEST`;
export const GET_TYPES_SUCCESS = `${prefix}/GET_TYPES_SUCCESS`;
export const GET_TYPES_FAILURE = `${prefix}/GET_TYPES_FAILURE`;

export const getTypes = () => ({
  types: [GET_TYPES_REQUEST, GET_TYPES_SUCCESS, GET_TYPES_FAILURE],
  promise: api => api.article.getTypes(),
});

export const RECENT_REQUEST = `${prefix}/RECENT_REQUEST`;
export const RECENT_SUCCESS = `${prefix}/RECENT_SUCCESS`;
export const RECENT_FAILURE = `${prefix}/RECENT_FAILURE`;

export const getRecent = () => ({
  types: [RECENT_REQUEST, RECENT_SUCCESS, RECENT_FAILURE],
  promise: api => api.article.recent(),
});
export const RELATED_REQUEST = `${prefix}/RELATED_REQUEST`;
export const RELATED_SUCCESS = `${prefix}/RELATED_SUCCESS`;
export const RELATED_FAILURE = `${prefix}/RELATED_FAILURE`;

export const getRelated = params => ({
  types: [RELATED_REQUEST, RELATED_SUCCESS, RELATED_FAILURE],
  promise: api => api.article.list(params),
});

export const LIST_REQUEST = `${prefix}/LIST_REQUEST`;
export const LIST_SUCCESS = `${prefix}/LIST_SUCCESS`;
export const LIST_FAILURE = `${prefix}/LIST_FAILURE`;

export const list = params => ({
  types: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
  promise: api => api.article.list(params),
});

export const GET_REQUEST = `${prefix}/GET_REQUEST`;
export const GET_SUCCESS = `${prefix}/GET_SUCCESS`;
export const GET_FAILURE = `${prefix}/GET_FAILURE`;

export const getItem = id => ({
  types: [GET_REQUEST, GET_SUCCESS, GET_FAILURE],
  promise: api => api.article.get(id),
});

export const LIST_ADMIN_REQUEST = `${prefix}/LIST_ADMIN_REQUEST`;
export const LIST_ADMIN_SUCCESS = `${prefix}/LIST_ADMIN_SUCCESS`;
export const LIST_ADMIN_FAILURE = `${prefix}/LIST_ADMIN_FAILURE`;

export const getListAdmin = (params = {}) => ({
  types: [LIST_ADMIN_REQUEST, LIST_ADMIN_SUCCESS, LIST_ADMIN_FAILURE],
  promise: api => api.article.listAdmin(params),
});

export const ITEM_ADMIN_REQUEST = `${prefix}/ITEM_ADMIN_REQUEST`;
export const ITEM_ADMIN_SUCCESS = `${prefix}/ITEM_ADMIN_SUCCESS`;
export const ITEM_ADMIN_FAILURE = `${prefix}/ITEM_ADMIN_FAILURE`;

export const getItemAdmin = id => ({
  types: [ITEM_ADMIN_REQUEST, ITEM_ADMIN_SUCCESS, ITEM_ADMIN_FAILURE],
  promise: api => api.article.itemAdmin(id),
});

export const ADD_REQUEST = `${prefix}/ADD_REQUEST`;
export const ADD_SUCCESS = `${prefix}/ADD_SUCCESS`;
export const ADD_FAILURE = `${prefix}/ADD_FAILURE`;

export const add = article => ({
  types: [ADD_REQUEST, ADD_SUCCESS, ADD_FAILURE],
  promise: api => api.article.add(article),
});

export const UPDATE_REQUEST = `${prefix}/UPDATE_REQUEST`;
export const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`;
export const UPDATE_FAILURE = `${prefix}/UPDATE_FAILURE`;

export const update = article => ({
  types: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
  promise: api => api.article.update(article),
});

export const REMOVE_REQUEST = `${prefix}/REMOVE_REQUEST`;
export const REMOVE_SUCCESS = `${prefix}/REMOVE_SUCCESS`;
export const REMOVE_FAILURE = `${prefix}/REMOVE_FAILURE`;

export const remove = id => ({
  types: [REMOVE_REQUEST, REMOVE_SUCCESS, REMOVE_FAILURE],
  promise: api => api.article.remove(id),
});

export const SET_FILE = `${prefix}/SET_FILE`;

export const setFile = files => ({
  type: SET_FILE,
  data: files,
});

export const SAVE_FILE_REQUEST = `${prefix}/SAVE_FILE_REQUEST`;
export const SAVE_FILE_SUCCESS = `${prefix}/SAVE_FILE_SUCCESS`;
export const SAVE_FILE_FAILURE = `${prefix}/SAVE_FILE_FAILURE`;

export const saveFile = (id, fileId = null, pdfId = null) => select => {
  const files = select(fileToSave);

  if (!files.length)
    return {
      type: SAVE_FILE_SUCCESS,
      data: { itemId: id },
    };
  const formData = new FormData();
  formData.append('id', id);
  if (fileId) formData.append('fileId', fileId);
  if (pdfId) formData.append('pdfId', pdfId);
  files.forEach(file => {
    formData.append(file.fileKey, file, file.name);
  });
  return {
    types: [SAVE_FILE_REQUEST, SAVE_FILE_SUCCESS, SAVE_FILE_FAILURE],
    promise: api => api.article.saveFile(formData),
  };
};
